import type {Standard} from "./types.ts";

// Concise version of _.groupBy (see https://stackoverflow.com/a/34890276)
export const groupBy = <T>(input: Array<T>, cb: (arg1: T) => string) => {
    return input.reduce(
        (output: Record<string, any>, x: any) => {
            const key = cb(x);
            (output[key] = output[key] || []).push(x);
            return output;
        },
        {} as Record<string, any>,
    );
};

// Some content items are tagged with very many (5+) CCSS Math standards.
// This is unwieldy to display, so we filter out those that are less specific
// if a more specific version is also present.
export const keepMostSpecificCommonCoreMathStandards = (
    standards: Array<Standard>,
): Array<Standard> => {
    // Find standard codes ending in letters, e.g. 8.EE.C.7b
    const codes = standards.map((standard) => standard.code);
    const codesEndingInLetters = codes.filter((code) => /[a-z]$/.test(code));

    // We don't want to keep the shorter version of those codes, e.g. 8.EE.C.7
    const codesToExclude = codesEndingInLetters.map((code) =>
        code.slice(0, -1),
    );
    return standards.filter(
        (standard) => !codesToExclude.includes(standard.code),
    );
};
